import { Typography } from "@mui/material";

interface IProps {
  annuallyPrice: number;
  priceInfo: string;
  minWidth?: { xs: number | string; md: number | string } | string;
}

export const PlanTotalPricing: React.FC<IProps> = ({
  annuallyPrice,
  priceInfo,
  minWidth = "auto",
}) => {
  return (
    <>
      <Typography variant="h3" component="p" color="text.accent" mb={0.5}>
        <Typography
          variant="h3"
          color="text.accent"
          component="span"
          fontSize={{ sm: 20, md: 28, lg: 28 }}
          sx={{ minWidth, display: "inline-block" }}
        >
          ${annuallyPrice}
        </Typography>
        <Typography
          variant="body1"
          component="span"
          color={{ xs: "text.secondary", md: "text.primary" }}
          fontWeight={700}
        >
          {" "}
          Per device{" "}
        </Typography>
        <Typography variant="body1" component="span" color="text.secondary">
          /mo{" "}
        </Typography>
      </Typography>
      <Typography variant="body1" component="span" color="text.secondary">
        {priceInfo}
      </Typography>
    </>
  );
};
